import ExtendableError from '../lib/ExtendableError';

export class PaymentUnauthorizedError extends ExtendableError {
    name = 'PaymentUnauthorizedError';
}

export class PaymentSettlementPendingError extends ExtendableError {
    name = 'PaymentSettlementPendingError';
}
